var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('money',_vm._b({staticClass:"form-control",attrs:{"size":"lg"},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}},'money',_vm.money,false))}
var staticRenderFns = []

export { render, staticRenderFns }